/**
 * @generated SignedSource<<71ab56ca0a59fda5a34e73cdb63537bb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableDetailsTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_user" | "PdpRespSharedSellerDetails_user" | "PdpSharedBuyerIncentives_user">;
  readonly " $fragmentType": "PdpRespUnavailableDetailsTabs_user";
};
export type PdpRespUnavailableDetailsTabs_user$key = {
  readonly " $data"?: PdpRespUnavailableDetailsTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableDetailsTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableDetailsTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSellerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8c72b55799b7064209bbdb355738aa5f";

export default node;
